import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=e09af680&"
import script from "./page-header.vue?vue&type=script&lang=js&"
export * from "./page-header.vue?vue&type=script&lang=js&"
import style0 from "./page-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgLink: require('/opt/build/repo/storefront/components/legacy/global/sg-link.vue').default,BaseTag: require('/opt/build/repo/storefront/components/atoms/Tags/BaseTag.vue').default,SgImg: require('/opt/build/repo/storefront/components/legacy/global/sg-img.vue').default,BaseIcon: require('/opt/build/repo/storefront/components/atoms/Icon/BaseIcon.vue').default,Flag: require('/opt/build/repo/storefront/components/legacy/global/flag.vue').default})
